module.exports = __webpack_public_path__ + "img/123s.7c3acacd.png";